import { cloneDeep, forEach, set } from "lodash";
import type { Reducer } from "redux";
import type { ResultDto } from "types/Result";
import { ReportCommentsActionTypes, type ReportCommentsState } from "./types";

const initialState: ReportCommentsState = {
	states: {},
	results: {},
};

const reducer: Reducer<ReportCommentsState> = (
	state = initialState,
	action,
) => {
	switch (action.type) {
		case ReportCommentsActionTypes.GET_SHARED_REPORT_COMMENTS_REQUEST: {
			const newStates = cloneDeep(state.states);
			const { requestId } = action.payload;
			set(newStates, `${requestId}.isLoading`, true);
			set(newStates, `${requestId}.error`, null);
			return {
				...state,
				states: newStates,
			};
		}
		case ReportCommentsActionTypes.GET_REPORT_COMMENTS_REQUEST: {
			const newStates = cloneDeep(state.states);
			const { requestId } = action.payload;
			set(newStates, `${requestId}.isLoading`, true);
			set(newStates, `${requestId}.error`, null);
			return {
				...state,
				states: newStates,
			};
		}
		case ReportCommentsActionTypes.GET_REPORT_COMMENTS_SUCCESS: {
			const states = cloneDeep(state.states);
			const { requestId } = action.payload;
			set(states[requestId], "isLoading", false);
			set(states[requestId], "hasLoaded", true);
			set(states[requestId], "error", null);
			const results = cloneDeep(state.results);
			const hasResult = Boolean(results[requestId]);
			const payloadResult = action.payload.result as ResultDto;
			if (hasResult) {
				// merge
				const newRequestResult = results[requestId];
				const newRounds = payloadResult.rounds.filter((round) =>
					newRequestResult.rounds.find(
						(requestResultRound) => round._id !== requestResultRound._id,
					),
				);
				newRequestResult.rounds.push(...newRounds);
				forEach(payloadResult.comments, (value, resultId) => {
					const hasResultId = Boolean(newRequestResult.comments[resultId]);
					if (hasResultId) {
						newRequestResult.comments[resultId].comments.push(
							...value.comments,
						);
					} else {
						newRequestResult.comments[resultId] = value;
					}
					newRequestResult.comments[resultId].availableComments =
						value.availableComments;
				});
			} else {
				// save new
				results[action.payload.requestId] = {
					...action.payload.result,
					segmentPath: action.payload.segmentPath,
				};
			}
			return {
				...state,
				states,
				results,
			};
		}
		case ReportCommentsActionTypes.GET_REPORT_COMMENTS_ERROR: {
			const states = cloneDeep(state.states);
			set(states[action.payload.requestId], "isLoading", false);
			set(states[action.payload.requestId], "error", action.payload.error);
			return {
				...state,
				states,
			};
		}
		default: {
			return state;
		}
	}
};

export { reducer as reportCommentsReducer };
